/**
 * Helpers compartilhados entre GestaoAgentesIa e ModalAgenteIa.
 */

export function extrairDados(resposta) {
  return resposta?.data?.data ?? resposta?.data ?? [];
}

export function obterMensagemErro(erro, mensagemPadrao) {
  return erro?.response?.data?.erro || erro?.response?.data?.message || mensagemPadrao;
}
